import { useState } from 'react'
import styled from '@emotion/styled'
import Button from '@mui/material/Button'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'
import { motion } from 'framer-motion'
import { useHistory } from 'react-router-dom'
import { colors } from '@global/constants'
import { forgotPassword } from '../authed/auth.actions'
import { t } from '@lingui/core/macro'

const BackButton = styled(Button)`
  margin-right: 8px;
`

const FloatRight = styled.div`
  padding-top: 35px;
  text-align: left;
`

const Form = styled.form`
  margin-top: 24px;
`

const Input = styled(TextField)`
  width: 100%;
`

export const ResetPassword = () => {
  const [email, setEmail] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const [done, setDone] = useState(false)
  const history = useHistory()

  const handleSubmit = e => {
    e.preventDefault()
    setError('')
    setLoading(true)
    forgotPassword(email)
      .then(() => {
        setLoading(false)
        setDone(true)
      })
      .catch(er => {
        setLoading(false)
        setError(er.data || 'Password could not be reset at this time.')
      })
  }

  return !done ? (
    <motion.div
      className="ResetPassword"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 0.5 } }}
      exit={{ opacity: 0, transition: { duration: 0.5 } }}
    >
      <Typography variant="h6" style={{ color: colors.gray.dark, fontWeight: 'bold' }}>
        {t`Forgot password?`}
      </Typography>
      <Typography variant="body2">
        {t`No problem. Enter your email below and we'll get you back to work in no time.`}
      </Typography>
      <Form onSubmit={handleSubmit}>
        <div>
          <Input
            variant="outlined"
            value={email}
            onChange={({ target: { value } }) => setEmail(value)}
            label={t`Email`}
            placeholder={t`john.doe@example.com`}
          />
        </div>
        <FloatRight>
          <BackButton
            onClick={() => {
              let url = '/auth/login'
              if (location.href.includes('login=system')) {
                url += '?login=system'
              }
              history.push(url)
            }}
            variant="contained"
            disableElevation={true}
            style={{
              backgroundColor: colors.blue.main,
              color: colors.white,
              height: 40,
              width: 100,
            }}
          >
            {t`Back`}
          </BackButton>
          <Button
            variant="contained"
            disabled={loading}
            type="submit"
            disableElevation={true}
            style={{
              backgroundColor: colors.green.main,
              color: colors.white,
              height: 40,
              width: 100,
            }}
          >
            {t`Update`}
          </Button>
        </FloatRight>
        <Typography variant="body2" style={{ color: colors.red.main, marginTop: 25 }}>
          {error}
        </Typography>
      </Form>
    </motion.div>
  ) : (
    <motion.div
      className="ResetPassword"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 0.5 } }}
      exit={{ opacity: 0, transition: { duration: 0.5 } }}
    >
      <Typography variant="body2">
        {t`Your password reset email has been sent. Please check your inbox and follow the link provided.`}
      </Typography>
    </motion.div>
  )
}
